export enum ModalLocation {
  topRight,
  bottomRight,
}
